import React, {useEffect, useRef, useState} from "react";
import mapboxgl from 'mapbox-gl';
import { makeStyles } from '@material-ui/core/styles';
//import { createPortal } from "react-dom";
import Marcador from "./Marcador";
import 'mapbox-gl/dist/mapbox-gl.css';
 
const useStyles = makeStyles({
    miclase:{".map-container":{
        height: "400px",
      }},
  });

function Mapa({lista, setActualiza, contador, setContador, ruta,listRutaGps  }) {
    
    const classes = useStyles();
    const mapContainer = useRef(null);
    const mapRef = useRef(null);    
    const [long] = useState(-66.15492523373541); 
    const [lat] = useState(-17.41283598717285);
    const [zoom] = useState(18);        
    const [regisSelect, setRegisSelect] = useState([]);       
 
    useEffect(() => {       
        console.log(lista,lista.length, );
        
        mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_KEY;
        mapRef.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: "mapbox://styles/mapbox/light-v10",
           center: lista.length!==0 ?[lista[lista.length-1].geometry.coordinates[0], lista[lista.length-1].geometry.coordinates[1]] :[ruta.centro[0], ruta.centro[1]],//?? [long, lat],
           //center:[ruta.centro[0], ruta.centro[1]],//?? [long, lat],
            zoom: zoom            
        });
                 
        mapRef.current.on('click', (e) => {                
            e.preventDefault()
            //let nvoMarcador=[]        
            //const geometry = { coordinates:[e.lngLat.lng.toFixed(5), e.lngLat.lat.toFixed(5)] } 
            const geometry = { coordinates:[e.lngLat.lng, e.lngLat.lat] } 
            const properties = {texto:"Nvo Marcador"}    
            const nvoMarcador = {geometry, properties, original:{Id:contador}}
           
            const auxLocalStg =  localStorage.getItem(`auxPolR${ruta.Id}`) ?  JSON.parse(localStorage.getItem(`auxPolR${ruta.Id}`)):[]
            if (auxLocalStg.length!==0) {                
                auxLocalStg.push(nvoMarcador)
                localStorage.setItem(`auxPolR${ruta.Id}`, JSON.stringify(auxLocalStg))
            }
            else{
                localStorage.setItem(`auxPolR${ruta.Id}`, JSON.stringify([nvoMarcador]))
            }
            
            setActualiza()
            setContador(contador+1)               
        });

        setRegisSelect(lista)
        return () => {
            mapRef.current.remove()
        }
    }, [ ]);

    useEffect(()=>{
        if (regisSelect.length!==0) {
            const auxCoordenadas=[]
            regisSelect.forEach((registro)=>{
                auxCoordenadas.push({... registro.geometry.coordinates})
            })
           
            if (auxCoordenadas.length!==0) {
                mapRef.current.flyTo({
                center:  [auxCoordenadas[auxCoordenadas.length-1][0], auxCoordenadas[auxCoordenadas.length-1][1]],
                zoom:18
            });    
            } 
            
            mapRef.current.on('load', () => {
                
                mapRef.current.addSource('maine', {
                    'type': 'geojson',
                    'data': {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'LineString',            
                            'coordinates': auxCoordenadas                        
                        }
                    }
                });
                mapRef.current.addLayer({
                    'id': 'dotted-maine',
                    'type': 'line',
                    'source': 'maine', // reference the data source
                    'layout': {
                        'line-join': 'round',
                        'line-cap': 'round'
                    },  
                    'paint': {
                        'line-color': 'red', // blue color fill
                        'line-width': 8,
                       // 'line-dasharray': [0.5, 2] //esta linea es la que hace los dots
                    }
                });           
            });
        }
 
    },[regisSelect])

   /*  useEffect(()=>{
        if (regisSelect.length!==0) {
            const auxCoordenadas=[]
            regisSelect.forEach((registro)=>{
                auxCoordenadas.push({... registro.geometry.coordinates})
            })
           
            if (auxCoordenadas.length!==0) {
                mapRef.current.flyTo({
                center:  [auxCoordenadas[auxCoordenadas.length-1][0], auxCoordenadas[auxCoordenadas.length-1][1]],
                zoom:18
            });    
            } 
            
            mapRef.current.on('load', () => {
                
                mapRef.current.addSource('maine-dot', {
                    'type': 'geojson',
                    'data': {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Point',            
                            'coordinates': [auxCoordenadas[auxCoordenadas.length-1][0], auxCoordenadas[auxCoordenadas.length-1][1]]                        
                        }
                    }
                });
                mapRef.current.addLayer({
                    'id': 'dotted-maine2',
                    'type': 'circle',
                    'source': 'maine-dot', // reference the data source
                    'layout': {
                        'line-join': 'round',
                        'line-cap': 'round'
                    },  
                    'paint': {
                       'circle-radius': 6,
                        'circle-color': '#B42222'                        
                    }
                });           
            });
        }
 
    },[regisSelect]) */

        /* useEffect(()=>{
        if (regisSelect.length!==0) {
            const auxCoordenadas=[]
            regisSelect.forEach((registro)=>{
                auxCoordenadas.push({... registro.geometry.coordinates})
            })
           
            if (auxCoordenadas.length!==0) {
                mapRef.current.flyTo({
                center:  [auxCoordenadas[auxCoordenadas.length-1][0], auxCoordenadas[auxCoordenadas.length-1][1]],
                zoom:18
            });    
            } 
            
            mapRef.current.on('load', () => {
                
                mapRef.current.addSource('maine', {
                    'type': 'geojson',
                    'data': {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'LineString',            
                            'coordinates': auxCoordenadas                        
                        }
                    }
                });
                mapRef.current.addLayer({
                    'id': 'maine',
                    'type': 'line',
                    'source': 'maine', // reference the data source
                    'layout': {
                        'line-join': 'round',
                        'line-cap': 'round'
                    },
                    'paint': {
                        'line-color': 'red', // blue color fill
                        'line-width': 8
                    }
                });           
            });
        }
 
    },[regisSelect]) */

    const onClick=(aux)=>{        
        console.log(aux);        
    }

    return (
    <div className={classes.miclase} style={{width:800,height: "15rem"}} >
       
        {<div id="districtDetailMap" className={"map"} >
            <div style={{width:800,height: 420}} ref={mapContainer}>
            </div>
   
           {  regisSelect.length !== 0 ?
                regisSelect.map((elemento)=>
                <Marcador
                    key={elemento.original.Id}
                    map={mapRef.current}
                    feature={elemento}
                    onClick={()=>{}}
                /> 
                )
               
          :null   }
           
        </div>}
    </div>
    );
}

export default Mapa;